import { Directive, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

import { environment } from 'environments/environment';

/**
 * This is a class that should be used to extend every component class.
 * This class will cleanup any observables when the component is destoryed.
 * This is to prevent memory leaks.
 */
//Angular 10 https://v10.angular.io/guide/migration-undecorated-classes
@Directive()
export class ComponentBase implements OnDestroy {
	ngUnsubscribe$ = new Subject();
	smallScreen: boolean = false;
	extraSmallScreen: boolean = false;
	constructor() {}

	ngOnDestroy() {
		this.unsubscribe();
	}

	unsubscribe() {
		this.ngUnsubscribe$.next(false);
		this.ngUnsubscribe$.unsubscribe();
	}

	navigateBack(): void {
		history.back();
	}

	/**
	 * Checks if the given value is null or blank (""), if the value has a value, the value is returned, if not then the placeholder is.
	 * @param value The value (as a string) to check.
	 * @param placeholder The string to replace the value with if it is blank or null.
	 * @returns The value OR placeholder.
	 */
	getValueOrPlaceholder(value: string | number, placeholder: string = '—'): string | number {
		return value || placeholder;
	}

	capitalize(text: string): string {
		return text.charAt(0).toUpperCase() + text.slice(1);
	}

	splitByCamelCase(label: string | number): string {
		label = typeof label == 'string' ? label : label.toString();
		// Splits words on CamelCase -> Camel Case
		label = label.replace(/([a-z])([A-Z])/g, '$1 $2');
		label = label.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
		return this.capitalize(label);
	}

	getValueOrDashIfEmpty(value: any): any {
		if (value) return value;
		return '—';
	}

	getTermsAndConditionsUrl(): string {
		return environment.winearkTermsAndConditionsUrl;
	}

	getManagedTermsUrl(): string {
		return environment.winearkManagedTermsUrl;
	}

	getDirectDebitTermsUrl(): string {
		return environment.winearkDirectDebitTermsUrl;
	}

	getMarketplaceTermsUrl(): string {
		return environment.winearkMarketplaceTermsUrl;
	}

	getInsuranceFaqUrl(): string {
		return environment.winearkInsuranceFaqUrl;
	}

	getRateScheduleUrl(): string {
		return environment.winearkRateScheduleUrl;
	}

	getPrivacyPolicyUrl(): string {
		return environment.winearkPrivacyPolicyUrl;
	}

	getSignUpPageUrl(): string {
		return `${environment.winePortalUrl}/sign-up`;
	}

	getWineManagedStorageCellarUrl(): string {
		return 'https://wineark.com.au/storage/managed-cellarage';
	}
}
